module.exports = __webpack_public_path__ + "static/media/2.7dcf99f7.jpg";